import React from "react";
import VerificationCompleted from "../VerificationCompleted/VerificationCompleted";

const ResetPasswordSuccess = () => {
  return <VerificationCompleted message={"Password Reset Successful"} />;
};

export default ResetPasswordSuccess;
